import { inject, injectable } from 'inversify-props';
import { IAppConfig, IAppConfigId } from '@/features/shared/IAppConfig';
import { AxiosId } from '@/plugins/axios';
import { AxiosInstance } from 'axios';
import { IDriverMessagesApi } from '@/features/messages/IDriverMessagesApi';
import { MessageTemplate } from '@/features/messages/MessageTemplate';
import { DriverMessage } from '@/features/messages/DriverMessage';
import { TransportType } from '@/features/shared/models/TransportType';

@injectable()
export default class DriverMessagesApi implements IDriverMessagesApi {
    @inject(IAppConfigId)
    config!: IAppConfig;

    @inject(AxiosId)
    axios!: AxiosInstance;

    getTemplates(transportType: TransportType): Promise<MessageTemplate[]> {
        return new Promise((resolve, reject) => {
            this.axios
                .get<MessageTemplate[]>('/api/drivermessages/gettemplates', {
                    params: {
                        token: this.config.token,
                        transportType
                    }
                })
                .then(response => {
                    const messages: MessageTemplate[] = response.data;
                    resolve(messages);
                })
                .catch(exception => {
                    reject(exception);
                });
        });
    }

    sendMessage(message: DriverMessage): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.axios
                .post('/api/drivermessages/sendmessage?token=' + this.config.token, message)
                .then(() => resolve())
                .catch(e => reject(e));
        });
    }
}
